import type React from "react";
import { AppRoutes } from "@/router/routes";

export const App: React.FC = () => {
	return <AppRoutes />;
};
